import React from 'react';
import { styled } from '@mui/material/styles';
import { GivelifyButton } from '../button';
import { GivelifyIcon } from '../icon';
import { GivelifyLabel } from '../label';

const BORDER_COLOR = '#CAD2DB';

const HeaderContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${BORDER_COLOR}`,
}));

const ButtonContainer = styled('div')(({ theme }) => ({
    width: 105,
    height: 72,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'center',
    borderRight: `1px solid ${BORDER_COLOR}`,
    [theme.breakpoints.down('sm')]: {
        height: 55,
        width: 56,
    },
}));

const LockIconStyled = styled(GivelifyIcon)(({ theme }) => ({
    width: 16,
    height: 21,
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
        height: 14,
        width: 11,
    },
}));

const HeadingLabel = styled(GivelifyLabel)(({ theme }) => ({
    fontWeight: 400,
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
        marginLeft: theme.spacing(3),
    },
}));

const LockTextLabel = styled(GivelifyLabel)(({ theme }) => ({
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        fontSize: 12,
    },
}));

interface ModalHeaderProps {
    heading: string;
    useBackArrow?: boolean;
    onClose: () => unknown;
    lockText?: string;
}

const ModalHeader: React.FCC<ModalHeaderProps> = ({
    heading,
    useBackArrow,
    onClose,
    lockText,
}) => {
    return (
        <HeaderContainer>
            <ButtonContainer>
                <GivelifyButton
                    name={useBackArrow ? 'back' : 'close'}
                    onClick={onClose}
                    variant="icon"
                >
                    {useBackArrow ? (
                        <GivelifyIcon fontSize={32} variant="left-arrow" />
                    ) : (
                        <GivelifyIcon fontSize={32} variant="close-outlined" />
                    )}
                </GivelifyButton>
            </ButtonContainer>
            <HeadingLabel
                id="onboarding-modal-title"
                text={heading}
                variant="h2legacy"
            />
            {lockText && (
                <>
                    <LockIconStyled color="neutralGrey" variant="lock" />
                    <LockTextLabel
                        id="onboarding-modal-lock-text"
                        text={lockText}
                        variant="body2"
                    />
                </>
            )}
        </HeaderContainer>
    );
};

export default React.memo(ModalHeader);
